import { render, staticRenderFns } from "./withdrawalReviewList.vue?vue&type=template&id=713588d6&"
import script from "./withdrawalReviewList.vue?vue&type=script&lang=js&"
export * from "./withdrawalReviewList.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalReviewList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports